import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import styles from './CompareIconArray.css'

import IconArray from '@healthwise-ui/core/IconArray'
import theme from '../common/theme'

class CompareIconArray extends Component {
  render() {
    const {
      minrange,
      maxrange,
      total,
      icontype,
      minRange,
      maxRange,
      iconType
    } = this.props
    const wrapperClasses = classNames({
      'hw-compare-icon-array': true,
      [styles.compare_icon_array]: true
    })

    return (
      <div className={wrapperClasses}>
        <IconArray
          minRange={minrange || minRange}
          maxRange={maxrange || maxRange}
          total={total}
          iconType={icontype || iconType}
          theme={theme.defaultTheme}
        />
      </div>
    )
  }
}

CompareIconArray.propTypes = {
  minrange: PropTypes.string,
  minRange: PropTypes.string,
  maxrange: PropTypes.string,
  maxRange: PropTypes.string,
  icontype: PropTypes.string,
  iconType: PropTypes.string,
  total: PropTypes.string
}

export default CompareIconArray



// WEBPACK FOOTER //
// /src/~/@healthwise/enhanced-shared-decision-point/components/CompareIconArray/index.js